import { Injectable } from '@angular/core';
import { FrappeApp, FrappeCall } from 'frappe-js-sdk';
import { AppConstant } from '../../app.constant';
import { FilterScheduleData, FilterScheduleDate } from '../../models/filter-schedule-data';

@Injectable({
  providedIn: 'root'
})
export class ScheduleService {
  private frappe: FrappeApp;
  private frappeCall: FrappeCall;
  constructor() {
    this.frappe = new FrappeApp(AppConstant.frappeUrl);
    this.frappeCall=this.frappe.call()
  }

  public getScheduleList(): Promise<any> {
    return this.frappeCall.get('vendor_portal.rest.get_all_schedule')
  }

  public getPageableScheduleList(data:any): Promise<any> {
    return this.frappeCall.get('vendor_portal.rest.get_pageable_schedule_list',{data})
  }

  public getFilterScheduleList(filterPo:FilterScheduleData,filterDate:FilterScheduleDate):Promise<any>{
    return this.frappeCall.get('vendor_portal.rest.filter_schedule',{data:JSON.stringify(filterPo),data2:JSON.stringify(filterDate)})
  }
}
